import { ActionDelegate } from 'containers/Base/ActionDelegate';
import { UndefinedAble } from 'data/base';
import { fetchProjectsDelegate } from './actions/FetchProjects';
import { fetchMoreProjectsDelegate } from './actions/FetchMoreProjects';
import { ProjectSelectorAction } from './actionTypes';
import { Project } from 'data/terra/Project';

export interface ProjectSelectorState {
  projects: Project[];
  hasInitialized: boolean;
  currentPage: number;
  isLoadingInit: boolean;
  hasMore: boolean;
  isLoadingMore: boolean;
  projectsError: UndefinedAble<string>;
  loadMoreError: UndefinedAble<string>;
}

const initialState: ProjectSelectorState = {
  projects: [],
  hasInitialized: false,
  currentPage: 0,
  isLoadingInit: false,
  hasMore: true,
  isLoadingMore: false,
  projectsError: undefined,
  loadMoreError: undefined,
};

const delegates: {
  [key: string]: ActionDelegate<any, ProjectSelectorState>;
} = {
  ...fetchProjectsDelegate,
  ...fetchMoreProjectsDelegate,
};

export default function reduce(
  state: ProjectSelectorState = initialState,
  action: ProjectSelectorAction
): ProjectSelectorState {
  const delegate = delegates[action.type];
  if (delegate) {
    return delegate(state, action);
  } else {
    return state;
  }
}
